import { cn } from '@/lib/utils'

interface Props {
  currentStep: number
  totalSteps: number
}

export const Stepper = ({ currentStep, totalSteps }: Props) => {
  return (
    <div className='flex items-center gap-4'>
      {Array.from({ length: totalSteps }, (_, index) => (
        <div
          key={index}
          className={cn('h-1 w-12 rounded-full', index === currentStep ? 'bg-icon-default' : 'bg-button-secondary-border-disabled')}
        />
      ))}
    </div>
  )
}
